import { createSlice } from "@reduxjs/toolkit";
import { Organization } from "types/organization";
import { SelectOrganizationThunk, setOrganizationsThunk } from "./thunks";

interface IState {
  organizations: Organization[] | null;
  organizationSelected: Organization | null;
}

const initialState: IState = {
  organizations: null,
  organizationSelected: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) =>
    builder
      .addCase(setOrganizationsThunk.fulfilled, (state, { payload }) => {
        state.organizations = payload;
      })
      .addCase(SelectOrganizationThunk.fulfilled, (state, { payload }) => {
        state.organizationSelected = payload;
      }),
});

export default organizationSlice;
